import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63298f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "data-row__content"
}
const _hoisted_2 = { class: "data-row__title" }
const _hoisted_3 = { class: "data-row__text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon icon-check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerData, (info) => {
      return (_openBlock(), _createElementBlock("div", {
        key: info.label,
        class: "data-row"
      }, [
        (info.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(info.label) + ": ", 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(info.content), 1)
              ]),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}